import { DocumentEditorFields } from '../../components-fields/document-editor-fields';

export const DocumentEditorFrenchTranslation: DocumentEditorFields = {
  Copy: 'Copier',
  Paste: 'Coller',
  Ok: 'Valider',
  'Insert Hyperlink': 'Insérer un lien',
  Hyperlink: 'Lien',
  'Font color': 'Couleur',
  'Font style': 'Style',
  Font: 'Police',
  Normal: 'Paragraphe',
  'Heading 1': 'Titre 1',
  'Heading 2': 'Titre 2',
  'Heading 3': 'Titre 3',
  'Heading 4': 'Titre 4',
  'Heading 5': 'Titre 5',
  'Heading 6': 'Titre 6',
  'Heading 7': 'Titre 7',
  'Heading 8': 'Titre 8',
  'Heading 9': 'Titre 9',
  'Heading 1 Char': 'Titre 1 caractère',
  'Heading 2 Char': 'Titre 2 caractère',
  'Heading 3 Char': 'Titre 3 caractère',
  'Heading 4 Char': 'Titre 4 caractère',
  'Heading 5 Char': 'Titre 5 caractère',
  'Heading 6 Char': 'Titre 6 caractère',
  'Heading 7 Char': 'Titre 7 caractère',
  'Heading 8 Char': 'Titre 8 caractère',
  'Heading 9 Char': 'Titre 9 caractère',
  'Default Paragraph Font': 'Police de paragraphe par défaut',
  'Header Char': 'Caractères d’en-tête',
  'Footer Char': 'Caractères de pied de page',
  'Linked Style': 'Lié (paragraphe et caractère)',
  Character: 'Caractère',
  'List Paragraph': 'Paragraphe de liste',
  'Manage Styles': 'Gérer les styles…',
};
